<div class="klabtime-date-filter">
    <button type="button" class="klabtime-date-filter__control" (click)="toggleDropdown()">
        <div class="klabtime-date-filter__left">
            <core-ui-icon name="icon_calendar"></core-ui-icon>

            <div class="klabtime-date-filter__texts">
                <span class="klabtime-date-filter__label">Fecha</span>
                <span class="klabtime-date-filter__value">{{ displayValue }}</span>
            </div>
        </div>

        <div class="klabtime-date-filter__right">
            <core-ui-icon name="chevron" [direction]="isOpen ? 'up' : 'down'" [color]="'#5F7081'"
                [extraClass]="'klab-sidebar__item-chevron'">
            </core-ui-icon>
        </div>
    </button>

    <div class="klabtime-date-filter__dropdown"
        [class.klabtime-date-filter__dropdown--align-right]="dropdownAlignRight"
        *ngIf="isOpen" (mousedown)="onPanelMouseDown()">
        <div class="klabtime-date-filter__quick-list" *ngIf="!isCustomOpen">
            <button type="button" class="klabtime-date-filter__option" *ngFor="let opt of quickOptions"
                [class.kd-selected]="opt.key === activeKey" (click)="onSelectQuickOption(opt.key)">
                {{ opt.label }}
            </button>
        </div>

        <div class="klabtime-date-filter__custom" *ngIf="isCustomOpen">
            <div class="klabtime-date-filter__custom-header">
                <span>Rango personalizado</span>
            </div>

            <div class="klabtime-date-filter__custom-body">
                <div class="kd-calendars">
                    <!-- Calendario izquierdo -->
                    <div class="kd-calendar">
                        <div class="kd-calendar__header">
                            <button *ngIf="canGoPrevMonth" type="button" class="kd-calendar__nav-btn"
                                (click)="onPrevMonth()">
                                <core-ui-icon name="chevron" [direction]="'left'"></core-ui-icon>
                            </button>

                            <span class="kd-calendar__month-label">
                                {{ leftMonthLabel }}
                            </span>
                        </div>

                        <div class="kd-calendar__weekdays">
                            <span *ngFor="let wd of weekDays">{{ wd }}</span>
                        </div>

                        <div class="kd-calendar__grid">
                            <button type="button" class="kd-calendar__day" *ngFor="let day of leftMonthDays"
                                [class.is-outside]="day.isOutside" [class.is-start]="isStart(day.date)"
                                [class.is-end]="isEnd(day.date)" [class.is-in-range]="isInRange(day.date)"
                                [class.kd-has-range]="hasRange" [class.is-disabled]="isDisabledDay(day.date)"
                                [class.is-out-window]="isOutOfRangeWindow(day.date)"
                                [disabled]="isDisabledDay(day.date)" (click)="onSelectDate(day.date)">
                                <span class="kd-calendar__day-inner">
                                    {{ day.label }}
                                </span>
                            </button>
                        </div>
                    </div>

                    <!-- Calendario derecho -->
                    <div class="kd-calendar">
                        <div class="kd-calendar__header kd-calendar__header--right">
                            <span class="kd-calendar__month-label">
                                {{ rightMonthLabel }}
                            </span>

                            <button *ngIf="canGoNextMonth" type="button" class="kd-calendar__nav-btn"
                                (click)="onNextMonth()">
                                <core-ui-icon name="chevron" [direction]="'right'"></core-ui-icon>
                            </button>
                        </div>

                        <div class="kd-calendar__weekdays">
                            <span *ngFor="let wd of weekDays">{{ wd }}</span>
                        </div>

                        <div class="kd-calendar__grid">
                            <button type="button" class="kd-calendar__day" *ngFor="let day of rightMonthDays"
                                [class.is-outside]="day.isOutside" [class.is-start]="isStart(day.date)"
                                [class.is-end]="isEnd(day.date)" [class.is-in-range]="isInRange(day.date)"
                                [class.kd-has-range]="hasRange" [class.is-disabled]="isDisabledDay(day.date)"
                                [class.is-out-window]="isOutOfRangeWindow(day.date)"
                                [disabled]="isDisabledDay(day.date)" (click)="onSelectDate(day.date)">
                                <span class="kd-calendar__day-inner">
                                    {{ day.label }}
                                </span>
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            <div class="klabtime-date-filter__custom-footer">
                <button type="button" class="kd-btn kd-btn--ghost" (click)="onCancelCustom()">
                    Cancelar
                </button>
                <button type="button" class="kd-btn kd-btn--primary" (click)="onApplyCustom()">
                    Aplicar
                </button>
            </div>
        </div>
    </div>
</div>